'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.config = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.info = info;
exports.success = success;
exports.warn = warn;

var _sweetalert = require('sweetalert');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _event = require('./core/event');

var _event2 = _interopRequireDefault(_event);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _localize = require('./core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common');
var log = (0, _debug2.default)('linksoft:message');

var config = exports.config = {
	'default': {},
	info: {
		type: 'info'
	},
	success: {
		type: 'success'
	},
	warn: {
		type: 'warning'
	},
	error: {
		type: 'error'
	},
	confirm: {
		type: 'warning',
		title: 'Are you sure?',
		showCancelButton: true,
		cancelButtonText: 'Cancel',
		confirmButtonColor: "#DD6B55",
		confirmButtonText: 'Yes'
	}
};

function showMessage(type, message, title, options) {
	if (!title) {
		title = message;
		message = undefined;
	}

	var opts = _extends({}, config.default, config[type], options, {
		title: title,
		text: message
	});

	return new Promise(function (resolve) {
		if (!opts.title) {
			log('title is missing: %o', opts);
			return resolve();
		}
		(0, _sweetalert2.default)(opts, function () {
			resolve();
		});
	});
}

function info(message, title, options) {
	return showMessage('info', message, title, options);
}

function success(message, title, options) {
	return showMessage('success', message, title, options);
}

function warn(message, title, options) {
	return showMessage('warn', message, title, options);
}

function error(message, title, options) {
	return showMessage('error', message, title, options);
}

function confirm(message, titleOrCallback, callback) {
	var userOpts = {
		text: message
	};

	if ((0, _isFunction2.default)(titleOrCallback)) {
		callback = titleOrCallback;
	} else if (titleOrCallback) {
		userOpts.title = titleOrCallback;
	}

	var opts = _extends({}, config.default, config.confirm, userOpts);

	return new Promise(function (resolve, reject) {
		if (!opts.title) {
			log('title is missing: %o', opts);
			return reject();
		}
		(0, _sweetalert2.default)(opts, function (isConfirmed) {
			callback && callback(isConfirmed);
			isConfirmed ? resolve() : reject();
		});
	});
}

exports.default = {
	info: info,
	success: success,
	warn: warn,
	error: error,
	confirm: confirm
};


_event2.default.on('linksoft.localeLoaded', function () {
	config.confirm.confirmButtonText = Resx.Common.Confirm;
	config.confirm.cancelButtonText = Resx.Common.Cancel;
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/message.js
// module id = 10
// module chunks = 0